// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__1eT-z","date":"style_date__1apCL","offline":"style_offline__1-1cx","offline-switch":"style_offline-switch__27b63","offline-text":"style_offline-text__zQd3b"};